<template>
	<input
    type="tel"
    class="afizo22"
    :value="value"
		ref="input"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
    @input="onInput($event.data, $event.target.value)" />
</template>

<script>
import "@/assets/css/index.css";

export default {
	name: "j-base-input-number",
	props: {
		value: {
			required: true,
			default: null,
			validator(val) {
				return val === null || typeof val === "string" || typeof val === "number"
			},
		},
	},
	data () {
		return {
			hasDecimal: false
		}
	},
	methods: {
		onInput(data, value) {
			// remove all non-digit and dot symbols
			if (data && data.match(/^[\d|\.]/gi) === null) {
				value = value.replace(data, "")
			}

			// remove dot if no decimels and using backspace
			if (data === null && value.match(/^\d+(\.)$/gi) !== null) {
				value = value.replace(/\./gi, "");
			}

			if (data === null && value.length === 0 ) {
				this.input = "";
			}
			
			// set input as value if number and has correct format
			if (value.match(/^\d+$/gi) !== null || value.match(/^\d+(\.\d{0,2})$/gi) !== null) {
				this.input = value;
			}

			this.$emit("input", this.input)

			// NOTE: when value is the same, component won't update when $emit
			// and thus input value is not changed so we have to forceUpdate the component everytime
			this.$forceUpdate()
		},
	},
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";
@import "../../assets/css/mixins.css";

.afizo22 {
	display: block;
	width: 100%;
	padding: var(--spacing2);
	background-color: var(--color5);
	border: 1px solid var(--color7);
	border-radius: var(--borderRadius1);
	font-family: var(--fontFamily1);
	font-weight: var(--fontWeight400);
	line-height: var(--lineHeight100);
	color: var(--color1);
	outline: 0;
	height: var(--inputsHeightNormal);
	font-size: var(--inputsFontSizeNormal);
	-webkit-appearance: none;
	-moz-appearance: none;
}

.afizo22::placeholder {
	color: var(--color7);
	font-size: inherit;
}

/* Sizes */
.afizo22.xsmall {
	height: var(--inputsHeightXsmall);
	font-size: var(--inputsFontSizeXsmall);
}
.afizo22.small {
	height: var(--inputsHeightSmall);
	font-size: var(--inputsFontSizeSmall);
}
.afizo22.large {
	height: var(--inputsHeightLarge);
	font-size: var(--inputsFontSizeLarge);
}
.afizo22.xlarge {
	height: var(--inputsHeightXlarge);
	font-size: var(--inputsFontSizeXlarge);
}

/* States */
.afizo22:focus {
	border-color: var(--color6);
}

.afizo22.success {
	border-color: var(--colorSuccess);
}

.afizo22.error {
	outline: 2px solid var(--colorError);
	outline-offset: -1px;
	animation: shake 900ms ease-out both;
}

.afizo22.warning {
	border-color: var(--colorWarning);
}

/* Desktops */
@media (--md) {
	.afizo22 {
		transition: all 80ms ease-out;
	}
}
</style>





// WEBPACK FOOTER //
// src/components/JBaseInputNumber/index.vue